import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const selectCreateSixState = (state: RootState) => state.createSix;

export const selectDraft = createSelector(selectCreateSixState, (state) => state.draft);

export const selectStep = createSelector(selectCreateSixState, (state) => state.step);

export const selectSubmitting = createSelector(selectCreateSixState, (state) => state.submitting);

export const selectFieldErrors = createSelector(selectCreateSixState, (state) => state.fieldErrors);

export const selectInternalUsers = createSelector(
  selectCreateSixState,
  (state) => state.internalUsers
);

export const selectExternalUsers = createSelector(
  selectCreateSixState,
  (state) => state.externalUsers
);

export const selectEditSixId = createSelector(selectCreateSixState, (state) => state.editSixId);

export const selectExternalSeatsAvailable = createSelector(
  selectCreateSixState,
  (state) => state.externalSeats?.available ?? 0
);
